import script from "./TutorTermsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorTermsContent.vue?vue&type=script&setup=true&lang=js"

import "./TutorTermsContent.vue?vue&type=style&index=0&id=75876044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75876044"]])

export default __exports__